module.exports = __webpack_public_path__ + "static/media/brightfoam.dd7dca8a.png";